import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=3aef116c&scoped=true&"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentRendererDefault.vue?vue&type=style&index=0&id=3aef116c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef116c",
  null
  
)

export default component.exports